import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchStores(page, pageSize) {
  const query = qs.stringify(
    { page, page_size: pageSize },
    { encodeValuesOnly: true }
  );
  const { data } = await api.get(`/store?${query}`);
  return data;
}

export function useStoresQuery(page, pageSize) {
  return useQuery({
    queryKey: ["store", page, pageSize],
    queryFn: () => fetchStores(page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useCreateStoreMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post("/store", payload);
      return data;
    }
  });
}

export function useUpdateStoreMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.post(`/store/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteStoreMutation() {
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/store/${id}`);
      return data;
    }
  });
}

